import DuckEntity from './DuckEntity'
import {entity as contacts} from './contacts';
import {arrayOf} from 'normalizr';

const entity = new DuckEntity('users', {
  apiPath: 'users',
  schemaDefinition: {
    contacts: arrayOf(contacts.schema)
  }
});
const reducer = entity.reducer;
export {reducer as default, entity};
